module.exports = __webpack_public_path__ + "img/task_unassigned.04c03473.svg";